// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Eg5i","selects":"Documents_selects__1jYz_"};